module.exports = __webpack_public_path__ + "static/media/ico_simulation_face_chin.8e9652ee.png";